// Map database IDs to friendly project names
const DB_DISPLAY_NAMES = {
  'pmd-preprod-db-gwa01': 'Global Wafers',
  'pmd-preprod-db-gfs01': 'GlobalFoundries',
  'pmd-preprod-db-pna01': 'Panasonic'
};

/**
 * Build report filename: "Project Name - Report Name[ - Grouped by Label] - YYYYMMDDHHmmss.ext"
 * @param {string}  reportName
 * @param {string}  extension
 * @param {string}  [groupByLabel]  — when set, inserts "Grouped by {label}" segment
 */
const buildReportFilename = (reportName, extension, groupByLabel) => {
  const dbId = localStorage.getItem('pmd-selected-database') || 'unknown';
  const dbName = DB_DISPLAY_NAMES[dbId] || dbId;

  const now = new Date();
  const timestamp = now.getFullYear().toString()
    + String(now.getMonth() + 1).padStart(2, '0')
    + String(now.getDate()).padStart(2, '0')
    + String(now.getHours()).padStart(2, '0')
    + String(now.getMinutes()).padStart(2, '0')
    + String(now.getSeconds()).padStart(2, '0');

  // Strip only characters illegal in Windows/Mac filenames; preserve hyphens, underscores, etc.
  const safeName = reportName.replace(/[\\/:*?"<>|]/g, '').trim();
  const groupSegment = groupByLabel
    ? ` - Grouped by ${groupByLabel.replace(/[\\/:*?"<>|]/g, '').trim()}`
    : '';

  return `${dbName} - ${safeName}${groupSegment} - ${timestamp}.${extension}`;
};

export default buildReportFilename;
